<template>
  <el-menu
    class="menu"
    text-color="$--base-color-black"
    :unique-opened="true"
    :default-active="$route.path"
    router
    active-text-color="$--base-color-main"
  >
    <el-submenu
      v-for="(submenu,index) in menuList"
      v-if="submenu.children.filter(item => user.permissionIds.includes(item.id)).length > 0 && !submenu.isHidden"
      :key="index"
      :index="index+''"
    >
      <template slot="title">
        {{ submenu.name }}
      </template>
      <el-menu-item
        v-for="item in submenu.children"
        v-if="user.permissionIds.includes(item.id) || item.id === null"
        :key="item.path"
        :index="item.path"
      >
        {{ item.name }}
      </el-menu-item>
    </el-submenu>
  </el-menu>
</template>
<script>
import { mapGetters } from 'vuex';
import { routes } from '@/router';

export default {
  name: 'SideMenu',
  data() {
    return {
      menuList: [],
      activeIndex: 0,
    };
  },
  computed: {
    ...mapGetters(['user']),
  },
  mounted() {
    // menuConfig
    console.log(this.$route);
    // menuConfig.forEach((menu) => {
    //   if (menu.children) {
    //     menu.children.forEach((sub) => {
    //       if (sub.children) {
    //         sub.children.forEach((child) => {
    //           menu.children.push(child);
    //         });
    //       }
    //     });
    //   }
    //   this.menuList.push(menu);
    // });
    this.initMenu();
  },
  methods: {
    // 生成菜单
    initMenu() {
      const routerList = routes[1].children;
      routerList.forEach((router) => {
        const menu = {};
        menu.id = router.meta.id;
        menu.name = router.meta.title;
        menu.isHidden = !!router.meta.isHidden;
        menu.children = [];
        router.children.forEach((subRouter) => {
          if (subRouter.meta.hideMenu === undefined) {
            let { path } = subRouter;
            if (subRouter.path.indexOf('/:') !== -1) {
              path = subRouter.path.split('/:').shift();
            }
            const sub = {
              id: subRouter.meta.id,
              name: subRouter.meta.title,
              path: `/${router.path}/${path}`,
              children: [],
            };
            menu.children.push(sub);
          }
        });
        this.menuList.push(menu);
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.menu {
  position: fixed;
  left: 0;
  top: 60px;
  height: calc(100% - 60px);
  width: 150px;
  font-size: 14px;
  z-index: 3;
  overflow: auto;
  .el-menu-item {
    min-width: auto;
    border-bottom: 1px solid rgba($color: $--base-color-black, $alpha: 0.1);
    &:hover {
      background: $--base-color-light;
      color: $--base-color-main !important;
    }
    &.is-active {
      background: $--base-color-light;
    }
  }
  .el-submenu {
    ::v-deep .el-submenu__title {
      border-bottom: 1px solid rgba($color: $--base-color-black, $alpha: 0.1);
      &:hover {
        background: $--base-color-light;
        color: $--base-color-main !important;
        i {
          color: $--base-color-main;
        }
      }
      i {
        color: $--base-color-black;
      }
    }
    &.is-opened {
      .el-menu-item {
        min-width: auto;
        background: $--base-color-light;
        color: $--base-color-black !important;
        &.is-active,
        &:hover {
          color: $--base-color-main !important;
        }
      }
      ::v-deep .el-submenu__title {
        // background: $--base-color-main;
        color: $--base-color-main !important;
        i {
          color: $--base-color-main;
        }
      }
    }
  }
}
</style>
